import type { ReactNode } from "react";
import { Message } from "@primereact/ui/message";
import { Fluid } from "@primereact/ui/fluid";
import { cx } from "./cx.js";

export function Field({
  label,
  htmlFor,
  error,
  hint,
  required = false,
  className,
  children,
}: {
  label: ReactNode;
  htmlFor?: string;
  error?: string;
  hint?: string;
  required?: boolean;
  className?: string;
  children: ReactNode;
}) {
  return (
    <Fluid asChild>
      <div className={cx("flex w-full flex-col gap-1.5", className)}>
        <label
          htmlFor={htmlFor}
          className="flex w-full flex-col gap-1.5 text-sm font-medium"
        >
          <span>
            {label}
            {required && (
              <span aria-hidden="true" className="ml-0.5 text-red-500">
                *
              </span>
            )}
          </span>
          {children}
        </label>

        {error ? (
          <Message.Root severity="error">
            <Message.Content>
              <Message.Text>{error}</Message.Text>
            </Message.Content>
          </Message.Root>
        ) : hint ? (
          <small className="p-text-secondary">{hint}</small>
        ) : null}
      </div>
    </Fluid>
  );
}
